import { AfterViewInit, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CreditCardPaymentService } from '../../shared/services/creditCardPayment.service';

@Component({
  selector: 'app-otp-page',
  templateUrl: './otp-page.component.html',
  styleUrls: ['./otp-page.component.scss']
})
export class OtpPageComponent implements AfterViewInit {
  constructor(
    public creditCardService: CreditCardPaymentService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngAfterViewInit(){
    const html = this.creditCardService.otpPage;
    if (html) {
      document.getElementById('otpDiv').innerHTML = html
      document.getElementById('otpDiv').getElementsByTagName('form')[0].target =
        '';
    }else this.router.navigate(['../'], { relativeTo: this.activatedRoute });
    eval(document.getElementById('authenticate-payer-script').innerText)
  }

}
